import React from 'react';
import './terminos.css'
import legales from '../images/bglegal.webp';

function Seguridad() {
return (
    <section className='legales' style={{ backgroundImage: `url(${legales})` }} name='legales'>
        <div className='content'>
        <h2>Politica de Seguridad de la Informacion</h2>

        <h5>1. Objetivo</h5>
        <p>El propósito de esta política es garantizar la confidencialidad, integridad y disponibilidad de los activos de información de <strong>EstudioIndex SRL</strong>. Establece directrices para proteger la información sensible contra accesos no autorizados, divulgación, alteración y destrucción.</p>

        <h5>2. Alcance</h5>
        <p><span>Esta política aplica a:</span></p>
        <p>- Todos los empleados, contratistas y proveedores de servicios externos de <strong>EstudioIndex SRL</strong>.</p>
        <p>- Todos los sistemas de información, datos y activos físicos de <strong>EstudioIndex SRL</strong>.</p>
        <p>- Todos los métodos de procesamiento y comunicación de la información (por ejemplo, correos electrónicos, almacenamiento en la nube y servidores locales).</p>

        <h5>3. Principios de Seguridad de la Información</h5>

        <h6>3.1 Confidencialidad</h6>
        <p>- La información sensible de <strong>EstudioIndex SRL</strong> debe ser accesible únicamente por el personal autorizado.</p>
        <p>- Todos los usuarios deben mantener estricta confidencialidad y evitar compartir información sensible con personas no autorizadas.</p>

        <h6>3.2 Integridad</h6>
        <p>- Todos los datos de <strong>EstudioIndex SRL</strong> deben ser precisos, completos y protegidos contra modificaciones no autorizadas.</p>
        <p>- Los cambios en datos críticos deben registrarse y revisarse regularmente.</p>

        <h6>3.3 Disponibilidad</h6>
        <p>- Los sistemas de información de <strong>EstudioIndex SRL</strong> deben estar disponibles para los usuarios autorizados según sea necesario para la continuidad del negocio.</p>
        <p>- Los sistemas deben incluir redundancias y copias de seguridad para prevenir interrupciones.</p>

        <h5>4. Responsabilidades</h5>

        <h6>4.1 Empleados y Contratistas</h6>
        <p>- Deben cumplir con las directrices de seguridad de <strong>EstudioIndex SRL</strong>.</p>
        <p>- Deben reportar de inmediato cualquier incidente de seguridad, violación o vulnerabilidad.</p>
        <p>- Son responsables de mantener contraseñas seguras y proteger las credenciales de acceso.</p>

        <h6>4.2 Oficial de Seguridad de la Información (ISO)</h6>
        <p>- Supervisa la implementación y el mantenimiento de esta política en <strong>EstudioIndex SRL</strong>.</p>
        <p>- Realiza auditorías de seguridad y evaluaciones de riesgos periódicas.</p>
        <p>- Proporciona programas de capacitación y concientización al personal.</p>

        <h6>4.3 Proveedores de Servicios Externos</h6>
        <p>- Deben firmar un acuerdo de procesamiento de datos que garantice el cumplimiento de los requisitos de seguridad de <strong>EstudioIndex SRL</strong>.</p>
        <p>- Están sujetos a auditorías para verificar el cumplimiento de esta política.</p>

        <h5>5. Uso Aceptable de los Sistemas de Información</h5>
        <p>- Los sistemas de <strong>EstudioIndex SRL</strong> deben ser utilizados estrictamente para fines empresariales.</p>
        <p>- Está estrictamente prohibido acceder, almacenar o compartir contenido no autorizado o ilegal.</p>
        <p>- Los dispositivos personales conectados a la red de <strong>EstudioIndex SRL</strong> deben cumplir con los estándares de seguridad.</p>

        <h5>6. Directrices para la Protección de Datos</h5>
        <p>- Cifrado: Todos los datos sensibles de <strong>EstudioIndex SRL</strong> deben cifrarse tanto en reposo como en tránsito.</p>
        <p>- Control de Acceso: El acceso a la información se otorga bajo el principio de mínima necesidad (need-to-know). Debe implementarse control de acceso basado en roles (RBAC).</p>
        <p>- Copias de Seguridad: Se deben mantener copias de seguridad regulares de los datos críticos en ubicaciones seguras.</p>

        <h5>7. Respuesta a Incidentes</h5>
        <p>- Reporte de Incidentes: Todos los incidentes de seguridad deben reportarse al ISO de <strong>EstudioIndex SRL</strong> dentro de las 24 horas.</p>
        <p>- Investigación: Todos los incidentes serán investigados de manera inmediata y se tomarán las medidas correspondientes.</p>
        <p>- Recuperación: Los sistemas y los datos deben restaurarse lo antes posible, minimizando el tiempo de inactividad operacional.</p>

        <h5>8. Seguridad Física</h5>
        <p>- Solo el personal autorizado tiene permitido el acceso a áreas restringidas de <strong>EstudioIndex SRL</strong>.</p>
        <p>- Los servidores y equipos críticos deben almacenarse en ubicaciones seguras con controles ambientales.</p>
        <p>- Los registros de acceso físico deben mantenerse y revisarse regularmente.</p>

        <h5>9. Cumplimiento</h5>
        <p>- Esta política cumple con las leyes, regulaciones y estándares aplicables, tales como:</p>
        <p>- Reglamento General de Protección de Datos (GDPR).</p>
        <p>- ISO/IEC 27001 Gestión de la Seguridad de la Información.</p>
        <p>- El incumplimiento de esta política puede resultar en medidas disciplinarias, incluyendo la terminación del contrato laboral.</p>

        <h5>10. Revisión y Actualización de la Política</h5>
        <p>- Esta política será revisada anualmente o cuando ocurran cambios significativos en las operaciones de <strong>EstudioIndex SRL</strong>, regulaciones o el panorama de amenazas.</p>
        <p>- Las sugerencias de mejoras pueden ser enviadas al ISO.</p>

        <p>Reconocimiento</p>
        <p>Todos los empleados y contratistas de <strong>EstudioIndex SRL</strong> deben reconocer que han leído, entendido y aceptado cumplir con esta política.</p>
        </div>
        <div className='legalBottom'><img src={`${process.env.PUBLIC_URL}/images/legal_bottom.webp`} alt='bottom' title='bottom'></img></div>
    </section>
    );
}
export default Seguridad;